import classnames from 'classnames'
import TopLine from 'components/header/TopLine'
import { Close } from 'components/lib/icons'
import NakedButton from 'components/lib/NakedButton'
import {
  HEADER_COMPONENTS,
  HEADER_STATES
} from 'constants/header'
import usePrevious from 'hooks/usePrevious'
import useSetPreviewHeight from 'hooks/useSetPreviewHeight'
import useThemeColors from 'hooks/useThemeColors'
import { toggleChat } from 'modules/view/actions'
import { chatHeaderType } from 'modules/view/selectors'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './style.css'

type HeaderLayoutProps = {
  chatHidden: boolean,
}

const HeaderLayout = ({ chatHidden }: HeaderLayoutProps) => {
  const dispatch = useDispatch()
  const { backgroundStyles, conversationHeaderTextStyles } = useThemeColors()
  const { hasConsent } = useSelector(state => (
    state.session.gdpr
  ))

  const { setChatHeight, setPreviewRef } = useSetPreviewHeight()
  const { chatOpen } = useSelector(state => state.view)

  const doToggleChat = () => {
    dispatch(toggleChat({ chatOpen: false }))
  }

  const [headerType, setHeaderType] = useState(useSelector(chatHeaderType))
  const prevHeaderType = usePrevious(headerType)
  const headerTypeChanged = headerType !== prevHeaderType

  useLayoutEffect(() => {
    if (chatOpen && !chatHidden) {
      setChatHeight(chatOpen, headerTypeChanged)
    }
  }, [chatOpen, chatHidden, setChatHeight, headerTypeChanged])

  const newHeaderType = useSelector(chatHeaderType)
  useEffect(() => {
    if (newHeaderType !== headerType) {
      setHeaderType(newHeaderType)
    }
  }, [newHeaderType, headerType])

  const resetChatHeight = () => {
    setChatHeight(chatOpen, true)
  }

  const HeaderComponent = HEADER_COMPONENTS[headerType]
  const isCollapsed = headerType !== HEADER_STATES.CONVERSATION

  return (
    <header className={classnames("drift-widget-header", {
      "drift-widget-header--collapsed": isCollapsed,
      "drift-widget-header--gdpr-consent": !hasConsent
    })}>
      <TopLine style={backgroundStyles} />

      <div className="drift-widget-header--content">
        <HeaderComponent previewRef={setPreviewRef} resetChatHeight={resetChatHeight} />
      </div>

      <NakedButton
        onClick={doToggleChat}
        className="drift-widget-close"
        aria-label="Close Drift Widget messenger"
        style={conversationHeaderTextStyles}
      >
        <Close width={16} height={16} />
      </NakedButton>
    </header>
  )
}

export default HeaderLayout
